import { ExpressionNode } from "../../text/lexer/expressions/ExpressionNode";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { ConstantExpression } from "../expressions/ConstantExpression";
import { ConstantExpressionFactory } from "../expressions/ConstantExpressionFactory";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { RJToken } from "../expressions/RJToken";
import { SequenceExpression } from "../expressions/SequenceExpression";
import { RJParserMessages } from "../parsers/RJParserMessages";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";
import { Operator } from "./Operator";

export class SequenceOperator extends Operator
{
  _symbol:string;

  constructor( parser:RJParser, symbol:string )
  {
    super( parser );
    this.setStartToken( RJLexer.OperatorMatcher.type, symbol );
    this._symbol = symbol;
  }

  processStartNode( nodes:RJExpressionNode[], index:number ):boolean
  {

    if ( index !== 1 )
    {
      this._parser.error( RJParserMessages.unexpectedSeperatorPosition, nodes[ index ].sourceInfo );
      return false;
    }

    let expressions:RJExpressionNode[] = []; 

    for ( let i = 0; i < nodes.length; i++ )
    {
      let node = nodes[ i ];
      let indexModulo2 = i % 2;
      let shouldBeExpression = indexModulo2 === 0; 
      let shouldBeSeperator  = indexModulo2 === 1;

      if ( shouldBeSeperator && ! node.isToken( RJLexer.OperatorMatcher.type, this._symbol ) )
      {
        this._parser.error( RJParserMessages.expectedSeperator, node.sourceInfo );
        return;        
      }
      else if ( shouldBeExpression && node.isToken( RJLexer.OperatorMatcher.type, this._symbol ) )
      {
        this._parser.error( RJParserMessages.unexpectedSeperatorPosition, node.sourceInfo );
        return;     
      } 

      if ( shouldBeSeperator )
      {
        continue;
      } 

      expressions.push( node );
      
    }

    let se = new SequenceExpression( this._parser, SourceRange.fromAllNodes( expressions ) );

    RJExpressionNode.replaceRange( nodes, 0, nodes.length, se );

    se.setExpressions( expressions );


    return false;
  }
}